import React from 'react'
import { Route } from 'react-router-dom'
import { MenuLinks } from '@/constants/menu'
import type { RoutesProps } from './utils'

const Landing = React.lazy(() => import('../pages/marketing/Landing'))
const Login = React.lazy(() => import('../pages/auth/Login'))
const Register = React.lazy(() => import('../pages/auth/Register'))
const BetaForumRegistered = React.lazy(() => import('../pages/auth/BetaForumRegistered'))
const Logout = React.lazy(() => import('../pages/auth/Logout'))
const RecoverPassword = React.lazy(() => import('../pages/auth/RecoverPassword'))
const LockScreen = React.lazy(() => import('../pages/auth/LockScreen'))
const ConfirmMail = React.lazy(() => import('../pages/auth/ConfirmMail'))
const ResetPassword = React.lazy(() => import('../pages/auth/ResetPassword'))
const RegisterSuccess = React.lazy(() => import('../pages/auth/RegisterSuccess'))
const TwoFactorAuthentication = React.lazy(() => import('@/pages/auth/TwoFactorAuthentication'))
const BuySubscriptionPlan = React.lazy(() => import('@/pages/orbit/buy-subscription-plan/Index'))
const SubscriptionStatus = React.lazy(() => import('@/pages/auth/SubscriptionStatus'))
const Error404 = React.lazy(() => import('../pages/error/Error404'))
const Error500 = React.lazy(() => import('../pages/error/Error500'))
const AccessDenied = React.lazy(() => import('../pages/error/AccessDenied'))
const MaintenancePages = React.lazy(() => import('../pages/other/Maintenance'))

export const marketingPublicRoutes: RoutesProps[] = [{ path: '/', name: 'Home', element: <Landing />, route: Route }]

export const authRoutes: RoutesProps[] = [
	{ path: MenuLinks.Login, name: 'Login', element: <Login />, route: Route },
	{ path: MenuLinks.Register, name: 'Register', element: <Register />, route: Route },
	{ path: MenuLinks.BetaWelcome, name: 'Beta Welcome', element: <BetaForumRegistered />, route: Route },
	{ path: '/auth/logout', name: 'Logout', element: <Logout />, route: Route },
	{ path: MenuLinks.RecoverPassword, name: 'Recover Password', element: <RecoverPassword />, route: Route },
	{ path: '/auth/lock-screen', name: 'Lock Screen', element: <LockScreen />, route: Route },
	{ path: MenuLinks.ConfirmMail, name: 'Confirm Mail', element: <ConfirmMail />, route: Route },
	{ path: '/auth/reset-password', name: 'Reset Password', element: <ResetPassword />, route: Route },
	{ path: MenuLinks.RegisterSuccess, name: 'Register Success', element: <RegisterSuccess />, route: Route },
	{ path: MenuLinks.PublicPricing, name: 'Pricing', element: <BuySubscriptionPlan />, route: Route },
	{ path: MenuLinks.SubscriptionStatus, name: 'Subscription Warning', element: <SubscriptionStatus />, route: Route },
	{ path: MenuLinks.TwoFactorVerification, name: 'Two Factor Authentication', element: <TwoFactorAuthentication />, route: Route },
]

export const otherPublicRoutes: RoutesProps[] = [
	{ path: '*', name: 'Error - 404', element: <Error404 />, route: Route },
	{ path: '/error-404', name: 'Error - 404', element: <Error404 />, route: Route },
	{ path: '/error-500', name: 'Error - 500', element: <Error500 />, route: Route },
	{ path: '/access-denied', name: 'Access Denied', element: <AccessDenied />, route: Route },
	{ path: '/pages/maintenance', name: 'Maintenance', element: <MaintenancePages />, route: Route },
]
